import React, { Component } from 'react';

class Hobbies extends Component {
  
  render() {
    const hobbies = (
    <section id="hobbies" className="resume-section">
	<article className="container">
	  <div className="row">
		<div className="category-title col-md-12">
		  <div className="row">
			<div className="col-md-4">
			  <h2>Hobbies</h2>
			</div>
		  </div>
		</div>
		<div className="card-container">
		  <span className="col-md-3 col-md-offset-1 side-note hidden-print">Extra Curricular Activities</span>
		  <div className="col-md-6 resume-card">
			<h3 className="title hidden-print">Extra Curricular Activities<small>Sports &amp; Fun</small></h3>
			<div className="row list">
			  <div className="col-md-3">
				<ul className="list-unstyled">
				  <li>Reading</li>
				  <li>Coding</li>
				  <li>Football(soccer)</li>
				  <li>Marathons</li>
				  <li>Cricket</li>
				</ul>
			  </div>
			  <div className="col-md-3">
				<ul className="list-unstyled">
				  <li>Mixology</li>
				  <li>Traveling</li>
				  <li>Cooking</li>
				  <li>Gaming</li>
				  <li>Movies</li>
				</ul>
			  </div>
			</div>
		  </div>
		</div>
	  </div>
	</article>
  </section>
    
    );
    return (
         hobbies
    );
  }
  
}

export default Hobbies;



// WEBPACK FOOTER //
// ./src/components/resume-components/hobbies.js